export var SurveyInputPurpose;
(function (SurveyInputPurpose) {
    SurveyInputPurpose["TEXT"] = "TEXT";
    SurveyInputPurpose["EMAIL"] = "EMAIL";
    SurveyInputPurpose["PHONE"] = "PHONE";
})(SurveyInputPurpose || (SurveyInputPurpose = {}));
export var SurveyMediaKind;
(function (SurveyMediaKind) {
    SurveyMediaKind["IMAGE"] = "IMAGE";
    /** No longer offered and never accepted: a question that still lists it reads as if it didn't. */
    SurveyMediaKind["VIDEO"] = "VIDEO";
    /** A PDF, Word or Excel document. */
    SurveyMediaKind["FILE"] = "FILE";
})(SurveyMediaKind || (SurveyMediaKind = {}));
/** The kinds an upload question can allow; none allowed means all of them. */
export var OFFERED_SURVEY_MEDIA_KINDS = [SurveyMediaKind.IMAGE, SurveyMediaKind.FILE];
export var SurveyConditionSubject;
(function (SurveyConditionSubject) {
    SurveyConditionSubject["ANSWER"] = "ANSWER";
    SurveyConditionSubject["GUEST_CATEGORY"] = "GUEST_CATEGORY";
})(SurveyConditionSubject || (SurveyConditionSubject = {}));
export var SurveyConditionOperator;
(function (SurveyConditionOperator) {
    SurveyConditionOperator["GTE"] = "GTE";
    SurveyConditionOperator["LTE"] = "LTE";
    SurveyConditionOperator["EQUALS"] = "EQUALS";
    SurveyConditionOperator["NOT_EQUALS"] = "NOT_EQUALS";
    SurveyConditionOperator["INCLUDES_ANY"] = "INCLUDES_ANY";
})(SurveyConditionOperator || (SurveyConditionOperator = {}));
